
/* eslint-disable no-unused-vars */

import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AdditionalItem from './AdditionalItem.vue';
import { JobAdditionalItems } from '../../store/job-additional-items';
import { getModule } from 'vuex-module-decorators';

@Component({
  components: {
    AdditionalItem,
  },
})
export default class AdditionalItems extends Vue {
  @Prop() readonly jobId!: string;
  @Prop() hidePricePurchasing!: boolean;
  @Prop() hidePriceSelling!: boolean;
  @Prop({ default: true }) hidePriceList!: boolean;
  @Prop() editable!: boolean;
  @Prop() editPriceSelling!: boolean;
  @Prop() editPricePurchasing!: boolean;
  @Prop() editPriceList!: boolean;
  @Prop() editInvoicingTarget!: boolean;
  @Prop() context!: string;
  @Prop() readonly!: boolean;

  // Computed
  get store(): JobAdditionalItems {
    return getModule(JobAdditionalItems, this.$store);
  }

  get items() {
    return this.store.forJob(this.jobId);
  }
}
